import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as clusterAssignedRecords from '../../cluster-assigned-records'
import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * Releases the record-picker selection once an edit session on the assigned
 * collection ends (submit succeeded, submit failed, or the edit was
 * discarded) so stale checked items do not carry over to the next session.
 */
export const releaseSelectionOnModalClose = store.effects.create(
  (_: ec.Collection<TypeParams>['feature'], collection: Collection) =>
    ec.models.CollectionProducer.getEc$<clusterAssignedRecords.TypeParams>(
      ec.Name.Predefined.SpaceClusterAssignedRecord,
      { waitUntilReady: true },
    ).pipe(
      rxjs.switchMap(assignedRecordsEc =>
        rxjs
          .merge(
            assignedRecordsEc.plugins.editingPlugin.feature.actions.discard.success.observe(),
            assignedRecordsEc.plugins.editingPlugin.feature.actions.submit.success.observe(),
            assignedRecordsEc.plugins.editingPlugin.feature.actions.submit.error.observe(),
          )
          .pipe(
            rxjs.map(action =>
              collection.plugins.selectionPlugin.applied.actions.putInSelectionLookup
                .from(action)
                .create({
                  key: assignedRecordsEc.associations?.selectionTarget,
                  value: { release: true },
                }),
            ),
          ),
      ),
    ),
)
